import { invokeRPC } from './socket.js'

export function getReferenceFile(projectId) {
  return invokeRPC('referenceFile', 'getReferenceFile', { project_id: projectId })
}

export function doesCustomerHaveReferenceFiles(id) {
  const data = {}
  if (id) {
    data.customer_id = id
  }
  return invokeRPC('referenceFile', 'doesCustomerHaveReferenceFiles', data)
}

export function updateReferenceFile(data) {
  return invokeRPC('referenceFile', 'updateReferenceFile', data)
}